import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { useTheme } from '../context/ThemeProvider';
import { toast } from 'react-toastify';
import { toastStyles } from '../styles/styles';

const useUpdate = (queryKey, apiCall, defaultSuccessMessage = 'Item updated successfully', defaultErrorMessage = 'Item update failed') => {
    const queryClient = useQueryClient();
    const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isEdit, setIsEdit] = useState(false);

    const { theme } = useTheme();

    const mutation = useMutation({
        mutationFn: async (formData) => {
            const response = await apiCall(formData);
            return response.data;
        },
        onSuccess: (data) => {
            queryClient.invalidateQueries([queryKey]);
            toast.success(data?.message || defaultSuccessMessage, {
                ...toastStyles,
                theme: theme
            });
            handleCloseAll();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || defaultErrorMessage, {
                ...toastStyles,
                theme: theme
            });
            handleCloseAll();
        }
    });

    const handleEditItem = (item) => {
       
        setSelectedItem(item);
        setIsEditDialogOpen(true);
        setIsEdit(true);
    };

    const handleEditFormSubmit = (formData) => {
        if (formData) {
            mutation.mutate(formData);
        }
    };

    const handleCloseAll = () => {
        setSelectedItem(null);
        setIsEditDialogOpen(false);
        mutation.reset();
        setIsEdit(false);
    };

    return {
        update: handleEditItem,
        isLoading: mutation.isLoading,
        isError: mutation.isError,
        error: mutation.error,
        isSuccess: mutation.isSuccess,
        status: mutation.status,
        updateDialogProps: {
            isOpen: isEditDialogOpen,
            onClose: () => setIsEditDialogOpen(false),
            onSubmit: (formData) => handleEditFormSubmit(formData),
            selectedItem: selectedItem,
            isEdit: isEdit,
            setIsEdit: setIsEdit
        }
    };
};

export default useUpdate;
